module.exports = __webpack_public_path__ + "static/img/shopping-icon.8252471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping-icon.png
// module id = i69Z
// module chunks = 53